var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[(_vm.$vuetify.breakpoint.xsOnly)?_c('ProfileUser'):_vm._e(),(_vm.$vuetify.breakpoint.smAndUp)?_c('LabeledCard',{staticClass:"pt-10",attrs:{"label":_vm.$t('Профиль')}},[_c('ProfileUser')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }